"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightboxElement = null;
var currentImages = [];
var currentIndex = 0;
var zoomLevel = 1;
var panX = 0;
var panY = 0;
var isDragging = false;
var dragStartX = 0;
var dragStartY = 0;
var dragStartPanX = 0;
var dragStartPanY = 0;
var pinchStartDistance = 0;
var pinchStartZoom = 1;
var pinchStartPanX = 0;
var pinchStartPanY = 0;
var pinchMidX = 0;
var pinchMidY = 0;
var lastTapTime = 0;
var MIN_ZOOM = 1;
var MAX_ZOOM = 8;

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function ensureLightboxExists() {
  var _lightboxElement$quer, _lightboxElement$quer2, _lightboxElement$quer3, _lightboxElement$quer4;

  if (lightboxElement && document.body.contains(lightboxElement)) {
    return lightboxElement;
  }

  lightboxElement = document.createElement('dialog');
  lightboxElement.className = 'image-lightbox';
  lightboxElement.innerHTML = "\n    <div class=\"lightbox-backdrop\">\n      <button type=\"button\" class=\"lightbox-close\" aria-label=\"Close\">\xD7</button>\n      <div class=\"lightbox-content\">\n        <button type=\"button\" class=\"lightbox-nav lightbox-prev\" aria-label=\"Previous\">\u2039</button>\n        <div class=\"lightbox-image-wrapper\">\n          <img src=\"\" alt=\"\" class=\"lightbox-image\" draggable=\"false\" />\n        </div>\n        <button type=\"button\" class=\"lightbox-nav lightbox-next\" aria-label=\"Next\">\u203A</button>\n      </div>\n      <div class=\"lightbox-counter\"></div>\n    </div>\n  ";
  (_lightboxElement$quer = lightboxElement.querySelector('.lightbox-close')) === null || _lightboxElement$quer === void 0 ? void 0 : _lightboxElement$quer.addEventListener('click', close);
  (_lightboxElement$quer2 = lightboxElement.querySelector('.lightbox-prev')) === null || _lightboxElement$quer2 === void 0 ? void 0 : _lightboxElement$quer2.addEventListener('click', prev);
  (_lightboxElement$quer3 = lightboxElement.querySelector('.lightbox-next')) === null || _lightboxElement$quer3 === void 0 ? void 0 : _lightboxElement$quer3.addEventListener('click', next);
  (_lightboxElement$quer4 = lightboxElement.querySelector('.lightbox-backdrop')) === null || _lightboxElement$quer4 === void 0 ? void 0 : _lightboxElement$quer4.addEventListener('click', function (e) {
    if (isDragging) return;
    if (e.target.classList.contains('lightbox-backdrop')) close();
  });
  lightboxElement.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    }

    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });
  lightboxElement.addEventListener('close', function () {
    resetZoom();
  });
  var wrapper = lightboxElement.querySelector('.lightbox-image-wrapper');

  if (wrapper) {
    wrapper.addEventListener('wheel', handleWheel, {
      passive: false
    });
    wrapper.addEventListener('mousedown', handleMouseDown);
    wrapper.addEventListener('dblclick', handleDblClick);
    wrapper.addEventListener('touchstart', handleTouchStart, {
      passive: false
    });
    wrapper.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    wrapper.addEventListener('touchend', handleTouchEnd);
  }

  document.body.appendChild(lightboxElement);
  return lightboxElement;
}

function resetZoom() {
  zoomLevel = 1;
  panX = 0;
  panY = 0;
  isDragging = false;
  lastTapTime = 0;
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
  applyTransform();
}

function constrainPan() {
  var _lightboxElement;

  if (zoomLevel <= 1) {
    panX = 0;
    panY = 0;
    return;
  }

  var wrapper = (_lightboxElement = lightboxElement) === null || _lightboxElement === void 0 ? void 0 : _lightboxElement.querySelector('.lightbox-image-wrapper');
  if (!wrapper) return;
  var maxPanX = wrapper.clientWidth * (zoomLevel - 1) / 2;
  var maxPanY = wrapper.clientHeight * (zoomLevel - 1) / 2;
  panX = clamp(panX, -maxPanX, maxPanX);
  panY = clamp(panY, -maxPanY, maxPanY);
}

function applyTransform() {
  var _lightboxElement2;

  var img = (_lightboxElement2 = lightboxElement) === null || _lightboxElement2 === void 0 ? void 0 : _lightboxElement2.querySelector('.lightbox-image');
  if (!img) return;
  constrainPan();

  if (zoomLevel <= 1) {
    img.style.transform = '';
    img.style.cursor = '';
  } else {
    img.style.transform = "translate(".concat(panX, "px, ").concat(panY, "px) scale(").concat(zoomLevel, ")");
    img.style.cursor = isDragging ? 'grabbing' : 'grab';
  }
}

function getWrapperCenter() {
  var _lightboxElement3;

  var wrapper = (_lightboxElement3 = lightboxElement) === null || _lightboxElement3 === void 0 ? void 0 : _lightboxElement3.querySelector('.lightbox-image-wrapper');
  if (!wrapper) return null;
  var rect = wrapper.getBoundingClientRect();
  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2
  };
}

function zoomToPoint(clientX, clientY, newZoom) {
  var center = getWrapperCenter();
  if (!center) return;
  var pointX = clientX - center.x;
  var pointY = clientY - center.y;
  newZoom = clamp(newZoom, MIN_ZOOM, MAX_ZOOM);
  var factor = newZoom / zoomLevel;
  panX = pointX - factor * (pointX - panX);
  panY = pointY - factor * (pointY - panY);
  zoomLevel = newZoom;
  applyTransform();
}

function handleWheel(e) {
  e.preventDefault();
  var delta = e.deltaY;
  if (e.deltaMode === 1) delta *= 16;
  if (e.deltaMode === 2) delta *= 100;
  var newZoom = zoomLevel * Math.pow(0.998, delta);
  zoomToPoint(e.clientX, e.clientY, newZoom);
}

function handleDblClick(e) {
  e.preventDefault();

  if (zoomLevel > 1) {
    resetZoom();
    return;
  }

  zoomToPoint(e.clientX, e.clientY, 2.5);
}

function handleMouseDown(e) {
  if (zoomLevel <= 1 || e.button !== 0) return;
  e.preventDefault();
  isDragging = true;
  dragStartX = e.clientX;
  dragStartY = e.clientY;
  dragStartPanX = panX;
  dragStartPanY = panY;
  applyTransform();
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
}

function handleMouseMove(e) {
  if (!isDragging) return;
  panX = dragStartPanX + (e.clientX - dragStartX);
  panY = dragStartPanY + (e.clientY - dragStartY);
  applyTransform();
}

function handleMouseUp() {
  if (!isDragging) return;
  isDragging = false;
  applyTransform();
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
}

function getTouchDistance(t1, t2) {
  return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
}

function handleTouchStart(e) {
  if (e.touches.length === 2) {
    e.preventDefault();
    isDragging = false;
    var _ref = [e.touches[0], e.touches[1]],
        t1 = _ref[0],
        t2 = _ref[1];
    pinchStartDistance = getTouchDistance(t1, t2);
    pinchStartZoom = zoomLevel;
    pinchStartPanX = panX;
    pinchStartPanY = panY;
    var center = getWrapperCenter();

    if (center) {
      pinchMidX = (t1.clientX + t2.clientX) / 2 - center.x;
      pinchMidY = (t1.clientY + t2.clientY) / 2 - center.y;
    }
  } else if (e.touches.length === 1 && zoomLevel > 1) {
    isDragging = true;
    dragStartX = e.touches[0].clientX;
    dragStartY = e.touches[0].clientY;
    dragStartPanX = panX;
    dragStartPanY = panY;
  }
}

function handleTouchMove(e) {
  if (e.touches.length === 2 && pinchStartDistance > 0) {
    e.preventDefault();
    var _ref2 = [e.touches[0], e.touches[1]],
        t1 = _ref2[0],
        t2 = _ref2[1];
    var distance = getTouchDistance(t1, t2);
    var scale = distance / pinchStartDistance;
    var newZoom = clamp(pinchStartZoom * scale, MIN_ZOOM, MAX_ZOOM);
    var factor = newZoom / pinchStartZoom;
    panX = pinchMidX - factor * (pinchMidX - pinchStartPanX);
    panY = pinchMidY - factor * (pinchMidY - pinchStartPanY);
    zoomLevel = newZoom;
    applyTransform();
  } else if (e.touches.length === 1 && isDragging && zoomLevel > 1) {
    e.preventDefault();
    panX = dragStartPanX + (e.touches[0].clientX - dragStartX);
    panY = dragStartPanY + (e.touches[0].clientY - dragStartY);
    applyTransform();
  }
}

function handleTouchEnd(e) {
  if (e.touches.length < 2) {
    pinchStartDistance = 0;
  }

  if (e.touches.length === 0) {
    isDragging = false;
    applyTransform();
    var now = Date.now();

    if (now - lastTapTime < 300) {
      var touch = e.changedTouches[0];

      if (touch) {
        if (zoomLevel > 1) {
          resetZoom();
        } else {
          zoomToPoint(touch.clientX, touch.clientY, 2.5);
        }
      }

      lastTapTime = 0;
    } else {
      lastTapTime = now;
    }
  }
}

function updateDisplay() {
  if (!lightboxElement) return;
  resetZoom();
  var img = lightboxElement.querySelector('.lightbox-image');
  var counter = lightboxElement.querySelector('.lightbox-counter');
  var prevBtn = lightboxElement.querySelector('.lightbox-prev');
  var nextBtn = lightboxElement.querySelector('.lightbox-next');
  if (img) img.src = currentImages[currentIndex] || '';
  if (counter) counter.textContent = "".concat(currentIndex + 1, " / ").concat(currentImages.length);
  var hasMultiple = currentImages.length > 1;
  if (prevBtn) prevBtn.style.display = hasMultiple ? '' : 'none';
  if (nextBtn) nextBtn.style.display = hasMultiple ? '' : 'none';
  if (counter) counter.style.display = hasMultiple ? '' : 'none';
}

function open(images) {
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  currentImages = images;
  currentIndex = startIndex;
  var dialog = ensureLightboxExists();
  updateDisplay();
  dialog.showModal();
}

function close() {
  var _lightboxElement4;

  resetZoom();
  (_lightboxElement4 = lightboxElement) === null || _lightboxElement4 === void 0 ? void 0 : _lightboxElement4.close();
}

function next() {
  if (currentImages.length === 0) return;
  currentIndex = (currentIndex + 1) % currentImages.length;
  updateDisplay();
}

function prev() {
  if (currentImages.length === 0) return;
  currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
  updateDisplay();
}

function getImageSrc(el) {
  if (el instanceof HTMLImageElement) return el.src;
  if (el instanceof HTMLAnchorElement) return el.href;
  return '';
}
/**
 * Bind click handlers to images or image links within an element.
 * Supports both <img> elements (uses src) and <a> elements (uses href).
 * Call this after rendering content with images.
 *
 * @example
 * ImageLightbox.bindTo(contentElement)
 * ImageLightbox.bindTo(attachmentsContainer, 'a.attachment__link--image')
 */


function bindTo(element) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'img:not([src*="emojione"])';
  var all = Array.from(element.querySelectorAll(selector));
  var bindable = all.filter(function (el) {
    return !(el.parentElement instanceof HTMLAnchorElement && el.parentElement.href);
  });
  var srcs = bindable.map(getImageSrc).filter(Boolean);
  if (srcs.length === 0) return;
  bindable.forEach(function (el, index) {
    if (el.dataset.lightboxBound) return;
    el.dataset.lightboxBound = 'true';
    el.style.cursor = 'pointer';
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open(srcs, index);
    });
  });
}

var ImageLightbox = {
  bindTo: bindTo,
  open: open,
  close: close
};
var _default = ImageLightbox;
exports.default = _default;